module.exports = " <modal :click-overlay-close=false :show.sync=show :title=title> <div class=vc-confirm-content> <icon value=help_outline v-if=showIcon :size=36></icon> <span class=vc-confirm-text>{{msg}}</span> </div> <button slot=footer text=取消 @click=cancel></button> <button slot=footer text=确定 @click=sure></button> </modal> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modal/confirm.vue
 ** module id = 464
 ** module chunks = 1
 **/